export default __webpack_public_path__ + "static/media/ic8.64d232e6.gif";